import { useState, useEffect, useRef } from 'react';
import { withValidation } from './Validation';
import { createInputId } from '../../utils/utilities';
import MultiSelect from '../Inputs/MultiSelect';
import SelectOption from '../Inputs/SelectOption';
import TextArea from '../Inputs/TextArea';

const QuestionDropdownMultiselectWithText = (props) => {
    const { value, label, questionChoices, helperText, required, name } = props;
    const [choiceOther, setChoiceOther] = useState('')
    const [choiceOtherText, setChoiceOtherText] = useState('')
    const [choiceOtherSelected, setChoiceOtherSelected] = useState(false)
    const [selected, setSelected] = useState(value ? value : []);

    const multiSelectRef = useRef(null)
    const multiSelectOptions = questionChoices.map(choice => {
        return {
            label: choice.label || choice.text,
            value: choice.gka
        }
    })

    useEffect(() => {
        if (Array.isArray(value)) {
            setSelected(value)
        }
    }, [value])

    useEffect(() => {
        const foundChoiceOther = questionChoices.find(choice => choice.gka.includes('choice_other'))
        if (foundChoiceOther) {
            setChoiceOther(foundChoiceOther.gka)
        }
    }, [questionChoices])


    const handleChangeTextbox = (e) => {
        setChoiceOtherText(e.target.value)
        const selectedFormattedWithText = selected.map(item => {
            if (item.choice === choiceOther) {
                return {
                    choice: item.choice,
                    text: e.target.value
                }
            }
            return item;
        })
        setSelected(selectedFormattedWithText)
        props.handleChange({ target: { value: selectedFormattedWithText}})
    }

    const handleChange = (options) => {
        const selectionsMap = new Map(selected.map(v => [v.choice, v]))
    
        for (const option of options) {
            if (typeof option === 'string' && selectionsMap.has(option)) {
                selectionsMap.delete(option)
                continue
            }

            if (typeof option === 'object') {
                continue
            }

            const choice = multiSelectOptions.find(o => o.value === option)
            selectionsMap.set(option, { 
                choice: choice.value,
                text: choice.value === choiceOther ? choiceOtherText : ''
            })
        }
    
        const selectedFormatted = [...selectionsMap.values()]

        setSelected(selectedFormatted)
        setChoiceOtherSelected(selectedFormatted.length > 0 && selectedFormatted.find(o => o.choice === choiceOther))
        props.handleChange({ target: { value: selectedFormatted }})
    }

    const textInputId = createInputId(name + '_' + choiceOther)
    const errorStyle = helperText ? '[&_button]:!ring-cherry-red [&_button]:hover:!ring-cherry-red [&_button]:focus:!ring-cherry-red' : ''

    return (
        <div className={errorStyle}>
            <h6 className='text-base m-0 mb-2 font-normal' id={name}>
                {label} {required ? <span className='text-cherry-red'>*</span>: null}
            </h6>

            <MultiSelect
                ref={multiSelectRef}
                id={createInputId(name)}
                options={multiSelectOptions}
                defaultSelection={selected}
                onSelection={handleChange}
                renderOption={(option) => (
                    <SelectOption
                        label={option.label}
                        isSelected={Boolean(selected.find(o => o.choice === option.value))}
                    />
                )}
                renderValue={() => (
                    <div className={'flex flex-wrap h-full items-center'}>
                        {selected.length === 0 && <span data-testid='multiselect:none-selected' className={`text-base ml-1 ${helperText ? 'text-cherry-red' : ''}`}>Select one or more options...</span>}

                        {selected.length > 0 && <span data-testid='multiselect:some-selected' className='text-base ml-1'>{selected.length} option{selected.length > 1 ? 's' : ''} selected</span>}
                    </div>
                )}
            />

            {helperText && <p data-testid='multi-select-w-text-error' className='text-cherry-red m-0 text-sm mt-2'>{helperText}</p>}

            {choiceOtherSelected &&
                <div className='mt-2 [&>textarea]:w-full'>
                    <TextArea
                        id={textInputId}
                        testId={textInputId}
                        value={choiceOtherText}
                        onChange={handleChangeTextbox}
                        numRows={4}
                        placeholder='Please provide an explanation'
                    />
                </div>
            }
        </div>
    );

}

export default withValidation(QuestionDropdownMultiselectWithText);